import { Project } from "@brg/api";
import { createContext, useContext } from "react";

const ModerationContext = createContext({
    project: null as Project | null,
    toolsComponent: null as React.ReactNode | null,
    voteBlock: null as React.ReactNode | null,
});

export const useModerationContext = () => {
    return useContext(ModerationContext);
};

export default ModerationContext;import { Project } from "@brg/api";
import { createContext, useContext } from "react";

const ModerationContext = createContext({
    project: null as Project | null,
    toolsComponent: null as React.ReactNode | null,
    voteBlock: null as React.ReactNode | null,
});

export const useModerationContext = () => {
    return useContext(ModerationContext);
};

export default ModerationContext;